import { Form, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import RefundMoneyForm from "../../../component/refundMoneyForm";
import axiosInstance from "../../../utils/axios";

export default function RefundMoneyManageDetail() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState({});
  const params = useParams();
  const id = params?.id;

  const fetchRefundMoney = async () => {
    await axiosInstance.get(`/refund-money/getById/${params?.id}`)
      .then((res) => {
        const data = res?.data?.data[0];
        const values = {
          ...data,
        };
        setInitialValues(values);
      });
  };

  const onSubmit = async (values) => {
    try {
      if (id && id !== "tao-moi") {
        await axiosInstance.post(`/refund-money/update/${id}`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
          });
      } else {
        await axiosInstance.post(`/refund-money/create`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
            fetchRefundMoney();
          });
      }
      navigate("/admin/quan-ly-refund-money");
    } catch (error) {
      message.error(error);
    }
  };

  useEffect(() => {
    if (id && id !== "tao-moi") fetchRefundMoney();
    form.resetFields();
  }, [form, id]);

  return (
    <RefundMoneyForm
      id={id !== "create" ? id : undefined}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  );
}
